import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ListsService} from '../lists.service';
import {ParseService} from '../parse.service';
import {List} from '../model/list';
import {ListItem} from '../model/list-item';
import {Router} from '@angular/router';

@Component({
    selector: 'app-new-list',
    templateUrl: './new-list.component.html',
    styleUrls: ['./new-list.component.scss'],
    standalone: false
})
export class NewListComponent implements OnInit {

  formGroup: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder, private listService: ListsService, private parseService: ParseService, private router: Router) {
    this.formGroup = fb.group({
      name: fb.control('', Validators.required),
      list: fb.control('', Validators.required),
    });
  }

  ngOnInit(): void {
  }

  addList(): void {
    const items: ListItem[] = [];
    const listName = this.formGroup.get('name').value;
    const listText: string = this.formGroup.get('list').value;

    listText.split('\n')
      .map(line => this.parseService.parse(line))
      .filter(item => item !== null)
      .forEach(item =>  items.push(item));

    const list: List = {
      created: new Date(),
      name: listName,
      items,
    };

    this.listService.addList(list).then((listId) => {
      this.router.navigate(['/lists', listId]);
    });
  }
}
